import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_MAP } from 'src/constants';
import { getRecentlyViewedDevices, getRecentlyViewedOrgs } from 'src/utils/api';

export const useGetRecentlyViewedDevices = () => {
  const { data, isLoading, error, isError } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetRecentlyViewedDevices],
    queryFn: getRecentlyViewedDevices,
  });

  const isEmptyData = !isLoading && !error && !data?.length;

  return {
    data,
    isLoading,
    error,
    isError,
    isEmptyData,
  };
};

export const useGetRecentlyViewedOrgs = () => {
  const { data, isLoading, error, isError } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetRecentlyViewedOrgs],
    queryFn: getRecentlyViewedOrgs,
  });

  const isEmptyData = !isLoading && !error && !data?.length;

  return {
    data,
    isLoading,
    error,
    isError,
    isEmptyData,
  };
};
